// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__l6Xy4","iconArrow":"Buttons_iconArrow__JqKYr","iconPhone":"Buttons_iconPhone__tW5BI","orange":"Buttons_orange__GbcVi","black":"Buttons_black__lG64s"};